/**
 * The ring taxonomy (segments, colors, category mapping, progress folding) now lives in
 * `@liza/fhir-utils` (shared with patient-native); this module re-exports it and adds the
 * web-only CSS gradient helper. Existing `@liza/ui/utils/ringCategories` importers are unchanged.
 */
export {
  RING_CATEGORIES,
  RING_CATEGORY_COLORS,
  RING_CATEGORY_LABELS,
  foldProgressToRingSegments,
  getItemKindColor,
  getRingCategory,
  getTaskCategoryColor,
  type CategoryProgress,
  type RingCategory,
} from '@liza/fhir-utils';

/**
 * iOS-style icon fill for a category color: a subtle vertical gradient, lighter at the top and a
 * touch deeper at the bottom for a "lit from above" look. Use as a CSS `background`.
 */
export function getCategoryGradient(color: string): string {
  return `linear-gradient(180deg, color-mix(in oklab, white 22%, ${color}) 0%, color-mix(in oklab, black 8%, ${color}) 100%)`;
}
